import { jsx as _jsx } from "react/jsx-runtime";
import { Divider, makeStyles } from "@material-ui/core";
const useStyles = makeStyles({
    makeSpace: ({ space = 0 }) => ({
        marginTop: space,
        marginBottom: space,
    }),
});
export const SpacedDivider = (props) => {
    const classes = useStyles(props);
    return _jsx(Divider, { className: classes.makeSpace }, void 0);
};
export const Spaced = (props) => {
    const classes = useStyles(props);
    return _jsx("div", { className: classes.makeSpace }, void 0);
};
//# sourceMappingURL=SpacedDivider.js.map